import React, { memo, useState } from 'react';
import { useSelector } from 'react-redux';
import { ReactComponent as AIIcon } from '../../assets/img/icons/assistant/AI.svg';
import { LargeIconButton } from '../Buttons';
import { Popover } from '../Popover';
import AIAssistantChat from './AIAssistantChat';

const AIAssistantButton = ({ className }) => {
  const [showChat, setShowChat] = useState(false);
  const userUuid = useSelector(state => state.login?.user?.uuid);
  const restaurantUuid = useSelector(state => state.login?.restaurantUuid);
  const userType = useSelector(state => state.login?.user?.type);
  const disabled = restaurantUuid === 'select';

  return (
    <>
      <Popover.Wrapper>
        <LargeIconButton
          type="red"
          Icon={AIIcon}
          disabled={disabled}
          className={className}
          onClick={() => setShowChat(!showChat)}
        />
        
        {disabled ? <Popover position="bottom">Please select a restaurant</Popover> : null}
      </Popover.Wrapper>

      {showChat && userType ? (
        <AIAssistantChat
          onCancel={() => setShowChat(false)}
          userUuid={userUuid}
          restaurantUuid={restaurantUuid}
          userType={userType}
        />
      ) : null}
    </>
  );
};

export default memo(AIAssistantButton);
